import { DUEL_SIZE, WHITE, duelCells, duelPhase, isAction, squareCell } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const DUEL = '/art/duel.svg';

export const duelUi: VariantUi = {
  heroImage: DUEL,
  peek: [{ image: '/art/bP.svg' }, { image: '/art/bP.svg' }, { image: '/art/bP.svg' }, {}, { image: DUEL }, {}, { image: '/art/wP.svg' }, { image: '/art/wP.svg' }, { image: '/art/wP.svg' }],

  sideBoard(pos) {
    const fighting = duelPhase(pos);
    return {
      title: 'Duel',
      hint: fighting ? 'Reach the far row, take every pawn, or leave them stuck' : 'The winner moves on the big board',
      cols: DUEL_SIZE,
      rows: DUEL_SIZE,
      cells: duelCells(pos),
      cellOf: (sq) => ((sq & 7) < DUEL_SIZE && sq >> 3 < DUEL_SIZE ? squareCell(sq) : -1),
      isMove: isAction,
      active: fighting,
    };
  },

  twist(pos, you) {
    const mine = you === null || pos.turn === you;
    const name = pos.turn === WHITE ? 'White' : 'Black';
    if (duelPhase(pos)) return { text: mine ? `Duel! ${you === null ? `${name} to move` : 'Your move'}: win it to move on the big board.` : 'Duel! Their move.' };
    return { text: mine ? `${you === null ? `${name} won` : 'You won'} the duel: make your move on the big board.` : 'They won the duel and move next.', alert: true };
  },

  eventSound(e) {
    return e.t === 'fx' && e.kind === 'duel-won' ? 'levelup' : null;
  },

  // The duels would bury the real moves.
  hideInMoveList: (rec) => isAction(rec.move),
};
